import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminProductsSubMenusLinks from "@/components/menu/sub-menus/products/AdminProductsSubMenusLinks.vue";
import ProductDetails from "@/components/products/WineComponent.vue";
export default {
  name: "AdminWineDetails",
  components: {
    AdminProductsSubMenusLinks: AdminProductsSubMenusLinks,
    ProductDetails: ProductDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null
    };
  },
  created: function created() {
    this.id = this.$route.params.id;
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant
  }
};